import {GridWidgetFilter} from './grid-widget-filter';
import {SelectField} from './select-field';
import {RestArgument} from './rest-argument';
import { pdsUtils } from '../../pds-utils';

export class MultiSelectFilter extends GridWidgetFilter {

  //The key is what shows up in the UI next to the checkbox
  searchValues: {[key: string]: boolean} = {};

  isBlankOverride: boolean;

  isBlank(): boolean {
    if (this.isBlankOverride != null) {
      return this.isBlankOverride;
    }

    let isBlank = Object.keys(this.searchValues).find((key: string) => {
        return this.searchValues[key];
      }) == null; //blank if we don't find anything.

    return isBlank;
  }

  internalPassesFilter(dataFromDataRow): boolean {
    let allCheckBoxLabels: Array<string> = Object.keys(this.searchValues);
    let matches = allCheckBoxLabels.find((checkboxLabel) => {
      let shouldMatch = this.searchValues[checkboxLabel];
      if (shouldMatch) {
        //Retrieve underlying data for the checkbox label
        let selectedOption = (<SelectField>this.dataField).selectOptions.get(checkboxLabel);

        //Leave in this console.log commented out. It's REALLY nice for debugging.
        //console.log('Comparing: ' + dataFromDataRow + ' to ' + selectedOption);
        if (typeof selectedOption === 'function') {
          //NOTE: DataFromDataRow is just a piece of data from a dataRow object.
          //If you need the full DataRow passed in, add a property to each dataRow called self
          //and point it at its self.  Then when 'self' is extracted, the full data row will be passed into
          //the selectOption function.

          //Example
          // for (let student of students) {
          //   //self now points at the entire student.
          //   student.self = student;
          // }
          return selectedOption(dataFromDataRow) === true;
        } else if (typeof dataFromDataRow === 'string' && typeof selectedOption === 'string') {
          return dataFromDataRow.toUpperCase() === selectedOption.toUpperCase();
        } else {
          return dataFromDataRow === selectedOption;
        }
      }
      return false;
    });
    return matches != null;
  }

  preFilterUpdate(): void {
  }

  getTagName(): string {
    return 'pds-gw-multi-select-filter';
  }

  setQuickSearchValue(text: string | undefined): boolean {
    let valid = false;

    this.searchValues = {};
    if (text != null && text !== '') {
      //The search value is NOT blank, therefore the isBlank function needs to return that this filter is not blank.
      //However, there may not be any values so nothing will actually match.
      this.isBlankOverride = false;

      (<SelectField>this.dataField).selectOptions.forEach((value, key: string) => {
        if (key.toUpperCase().search(pdsUtils.escapeUserInput(text.toUpperCase())) >= 0) {
          this.searchValues[key] = true;
          valid = true;
        }
      });
    }

    return valid;
  }

  getRestArguments(): Array<RestArgument> {
    let arry: Array<RestArgument> = [];

    // tslint:disable-next-line:forin
    for (let key in this.searchValues) {
      let value = this.searchValues[key];
      if (value) {
        arry.push(new RestArgument(this.dataField.id, '=', (<SelectField>this.dataField).selectOptions.get(key)));
      }
    }

    return arry;
  }

  getTagText(): string {
    let arry: Array<string> = [];

    // tslint:disable-next-line:forin
    for (let key in this.searchValues) {
      let value = this.searchValues[key];
      if (value) {
        arry.push(key);
      }
    }

    return arry.join(', ');
  }

  getPersistenceObject(): Object | undefined {
    let state = {
      searchValues: this.searchValues,
      isBlankOverride: this.isBlankOverride
    };
    return state;
  }

  restoreFromPersistenceObject(value: Object): void {
    let state = <any>value;
    this.searchValues = state.searchValues || {};
    this.isBlankOverride = state.isBlankOverride;
  }
}
